import { DEFAULT_LOCALE, type SiteLocale } from '@/lib/i18n/locales';

type NonDefaultLocale = Exclude<SiteLocale, typeof DEFAULT_LOCALE>;

const normalizeSlug = (slug: string): string => slug.trim().replace(/^\/+|\/+$/g, '');

export const TRANSLATED_SLUGS_BY_LOCALE: Record<NonDefaultLocale, readonly string[]> = {
  en: [
    'abogado-extranjeria-alicante',
    'abogado-extranjeria-alto-parana',
    'abogado-extranjeria-ambato',
    'abogado-extranjeria-antioquia',
    'abogado-extranjeria-antofagasta',
    'abogado-extranjeria-aregua',
    'abogado-extranjeria-arequipa',
    'abogado-extranjeria-asuncion',
    'abogado-extranjeria-atlantico',
    'abogado-extranjeria-azuay',
    'abogado-extranjeria-barcelona',
    'abogado-extranjeria-barranquilla',
    'abogado-extranjeria-biobio',
    'abogado-extranjeria-bogota',
    'abogado-extranjeria-bolivar',
    'abogado-extranjeria-bucaramanga',
    'abogado-extranjeria-buenos-aires',
    'abogado-extranjeria-caaguazu',
    'abogado-extranjeria-cali',
    'abogado-extranjeria-callao',
    'abogado-extranjeria-canelones',
    'abogado-extranjeria-cartagena',
    'abogado-extranjeria-central',
    'abogado-extranjeria-chiclayo',
    'abogado-extranjeria-ciudad-del-este',
    'abogado-extranjeria-cochabamba',
    'abogado-extranjeria-concepcion',
    'abogado-extranjeria-coquimbo',
    'abogado-extranjeria-cordoba',
    'abogado-extranjeria-coronel-oviedo',
    'abogado-extranjeria-coruna',
    'abogado-extranjeria-cuenca',
    'abogado-extranjeria-cundinamarca',
    'abogado-extranjeria-cusco',
    'abogado-extranjeria-encarnacion',
    'abogado-extranjeria-girona',
    'abogado-extranjeria-granada',
    'abogado-extranjeria-guayaquil',
    'abogado-extranjeria-guayas',
    'abogado-extranjeria-houston',
    'abogado-extranjeria-illes-balears',
    'abogado-extranjeria-itapua',
    'abogado-extranjeria-la-libertad',
    'abogado-extranjeria-la-paz',
    'abogado-extranjeria-la-plata',
    'abogado-extranjeria-la-serena',
    'abogado-extranjeria-lambayeque',
    'abogado-extranjeria-las-palmas',
    'abogado-extranjeria-las-palmas-de-gran-canaria',
    'abogado-extranjeria-lima',
    'abogado-extranjeria-londres',
    'abogado-extranjeria-los-angeles',
    'abogado-extranjeria-madrid',
    'abogado-extranjeria-malaga',
    'abogado-extranjeria-maldonado',
    'abogado-extranjeria-manabi',
    'abogado-extranjeria-maule',
    'abogado-extranjeria-medellin',
    'abogado-extranjeria-miami',
    'abogado-extranjeria-mendoza',
    'abogado-extranjeria-metropolitana',
    'abogado-extranjeria-montevideo',
    'abogado-extranjeria-murcia',
    'abogado-extranjeria-nacionalidad-2026',
    'abogado-extranjeria-navarra',
    'abogado-extranjeria-neuquen',
    'abogado-extranjeria-nueva-york',
    'abogado-extranjeria-palma',
    'abogado-extranjeria-pamplona',
    'abogado-extranjeria-paysandu',
    'abogado-extranjeria-pereira',
    'abogado-extranjeria-pichincha',
    'abogado-extranjeria-piura',
    'abogado-extranjeria-portoviejo',
    'abogado-extranjeria-potosi',
    'abogado-extranjeria-quito',
    'abogado-extranjeria-risaralda',
    'abogado-extranjeria-rivera',
    'abogado-extranjeria-salta',
    'abogado-extranjeria-salto',
    'abogado-extranjeria-san-miguel-de-tucuman',
    'abogado-extranjeria-santa-cruz',
    'abogado-extranjeria-santa-cruz-de-la-sierra',
    'abogado-extranjeria-santa-cruz-de-tenerife',
    'abogado-extranjeria-santa-fe',
    'abogado-extranjeria-santander',
    'abogado-extranjeria-santiago',
    'abogado-extranjeria-santo-domingo',
    'abogado-extranjeria-sevilla',
    'abogado-extranjeria-talca',
    'abogado-extranjeria-tarija',
    'abogado-extranjeria-toronto',
    'abogado-extranjeria-trujillo',
    'abogado-extranjeria-tucuman',
    'abogado-extranjeria-tungurahua',
    'abogado-extranjeria-valencia',
    'abogado-extranjeria-valladolid',
    'abogado-extranjeria-valle-del-cauca',
    'abogado-extranjeria-valparaiso',
    'abogado-extranjeria-vizcaya',
    'abogado-extranjeria-zaragoza',
    'abogado-tramitar-nacionalidad-2026',
    'abogado-visado-estudiante-2026',
    'abogado-visado-no-lucrativo-2026',
    'abogados-renovacion-residencia-2026',
    'acelerar-nacionalidad-por-residencia-2026',
    'actualizaciones-estancia-por-estudios-2026',
    'alegaciones-homologacion-de-titulo',
    'arraigo-familiar',
    'arraigo-familiar-2026',
    'arraigo-familiar-vs-reagrupacion-2026',
    'arraigo-laboral',
    'arraigo-por-formacion',
    'arraigo-social',
    'arraigo-social-vs-laboral',
    'arraigo-segunda-oportunidad-2026',
    'arraigo-sociolaboral',
    'asesoria-nacionalidad-por-residencia-2026',
    'asilo-y-proteccion-internacional',
    'aspectos-legales-nacionalidad-2026',
    'autorizacion-regreso',
    'ayuda-visado-no-lucrativo-2026',
    'beneficios-nacionalidad-espanola-2026',
    'blog',
    'busqueda-empleo-estudiantes',
    'beckham-law-impatriados-2026',
    'cambio-domicilio-nacionalidad-2026',
    'certificado-registro-ue',
    'ciudadania-espanola-2026',
    'consejos-renovacion-tarjeta-comunitaria-2026',
    'consulta-juridica-estrategica',
    'contacto',
    'contrato-practicas',
    'cookies',
    'cuanto-tarda-arraigo-2026',
    'cuanto-tarda-nacionalidad-espanola-2026',
    'cuanto-tarda-renovar-residencia-2026',
    'cuanto-tarda-visado-estudiante-2026',
    'delitos-que-impiden-nacionalidad-2026',
    'denegacion-arraigo-que-hacer-2026',
    'denegacion-renovacion-residencia-2026',
    'dinero-para-entrar-a-espana-2026',
    'dispensa-nacionalidad-2026',
    'comprueba-tu-tramite-ia',
    'documentos-arraigo-social-2026',
    'empieza-tramite',
    'empieza-tu-tramite',
    'documentos-nacionalidad-por-residencia-2026',
    'documentos-regularizacion-2026',
    'documentos-renovar-residencia-2026',
    'documentos-visado-estudiante-2026',
    'edad-maxima-reagrupacion-hijos-2026',
    'el-camino-a-la-ciudadania-espanola',
    'errores-regimen-beckham-2026',
    'errores-comunes-arraigo-2026',
    'examenes-nacionalidad-ccse-dele-2026',
    'familiares-de-espanoles',
    'fiscalidad-internacional',
    'golden-visa',
    'guia-nacionalidad-espanola-2026',
    'guia-regularizacion-espana-2026',
    'guia-regularizacion-extranjeros-2026',
    'homologacion-de-titulos-profesionales',
    'homologacion-equivalencia-titulo-profesional',
    'inicio-sesion',
    'informe-arraigo-social-2026',
    'informe-vivienda-adecuada-2026',
    'internacionalizacion-de-empresas',
    'ley-beckham',
    'modificaciones-de-situacion',
    'mis-expedientes',
    'nacionalidad-denegada-que-hacer-2026',
    'nacionalidad-espanola-por-matrimonio-2026',
    'nacionalidad-por-opcion-menores-2026',
    'nie-no-residente',
    'nuevo-reglamento-2026',
    'nuevos-pasos-regularizacion-2026',
    'paises-con-visado-espana-2026',
    'papeles-renovar-permiso-residencia-2026',
    'pasos-nacionalidad-espanola-2026',
    'perder-tarjeta-comunitaria-2026',
    'permiso-de-residencia-y-trabajo',
    'permiso-residencia',
    'plazos-renovar-residencia-2026',
    'preguntas-frecuentes',
    'privacidad',
    'profesional-altamente-cualificado',
    'prorroga-estancia-por-estudios-2026',
    'puntos-clave-nacionalidad-2026',
    'quien-puede-regularizarse-2026',
    'reagrupacion-familiar',
    'reagrupacion-familiar-espana-2026',
    'recurso-de-alegaciones',
    'recurso-denegacion-renovacion-residencia-2026',
    'regularizacion-extraordinaria-2026',
    'regularizacion-paso-a-paso-2026',
    'regularizacion-rechazada-2026',
    'regularizacion-requisitos',
    'registrarse',
    'reiniciar-password',
    'renovaciones-residencia',
    'renovar-permiso-regularizacion-2026',
    'renovacion',
    'renovar-residencia-larga-duracion-2026',
    'renovar-tarjeta-residencia-espana-2026',
    'requisitos-economicos-visado-no-lucrativo-2026',
    'requisitos-nacionalidad-espanola-2026',
    'requisitos-nacionalidad-menores-2026',
    'residencia-larga-duracion',
    'residencia-no-lucrativa',
    'residencia-por-estudios',
    'residencia-trabajo',
    'residencia-trabajo-cuenta-propia',
    'residencia-y-trabajo-por-cuenta-propia',
    'servicios',
    'sube-documentacion',
    'tarjeta-comunitaria-renovacion-2026',
    'tarjeta-familiar-comunitario',
    'tasa-790-052-residencia-2026',
    'tiempo-minimo-residencia-nacionalidad-2026',
    'tipos-de-arraigo-espana-2026',
    'tramite-aceptado',
    'trabajar-mientras-espera-renovacion-2026',
    'trabajar-mientras-estudias-espana-2026',
    'trabajo-temporada',
    'victimas-de-violencia-de-genero',
    'victimas-violencia-genero',
    'visado-de-nomada-digital',
    'visado-denegado-que-hacer-2026',
    'visado-estancia-por-estudios',
    'visado-estudiante-denegado-2026',
    'visado-estudiante-paso-a-paso-2026',
    'visado-no-lucrativo-guia-2026',
    'visado-no-lucrativo-vivir-tranquilo-2026',
    'visado-nomada-digital',
    'visado-para-profesionales-altamente-cualificados',
  ],
  fr: [],
  de: [],
  it: [],
  pt: [],
  nl: [],
  ro: [],
  ar: [],
} as const;

const localeSlugSets = {} as Record<NonDefaultLocale, Set<string>>;
for (const locale of Object.keys(TRANSLATED_SLUGS_BY_LOCALE) as NonDefaultLocale[]) {
  localeSlugSets[locale] = new Set(TRANSLATED_SLUGS_BY_LOCALE[locale].map((slug) => normalizeSlug(slug)));
}

export function hasLocaleTranslation(locale: SiteLocale, slug: string): boolean {
  if (locale === DEFAULT_LOCALE) return true;
  return localeSlugSets[locale as NonDefaultLocale].has(normalizeSlug(slug));
}

export function getTranslatedSlugs(locale: SiteLocale): readonly string[] {
  if (locale === DEFAULT_LOCALE) return [];
  return TRANSLATED_SLUGS_BY_LOCALE[locale as NonDefaultLocale];
}

export function getLocalesWithTranslation(slug: string): SiteLocale[] {
  const normalizedSlug = normalizeSlug(slug);
  const locales: SiteLocale[] = [DEFAULT_LOCALE];

  (Object.keys(localeSlugSets) as NonDefaultLocale[]).forEach((locale) => {
    if (localeSlugSets[locale].has(normalizedSlug)) {
      locales.push(locale);
    }
  });

  return locales;
}

export function localeHasAnyTranslatedSlugs(locale: SiteLocale): boolean {
  if (locale === DEFAULT_LOCALE) return true;
  return TRANSLATED_SLUGS_BY_LOCALE[locale as NonDefaultLocale].length > 0;
}
